/**
 * brand.ts — Zustand store for brand settings signal.
 * Used to notify AppLayout to re-apply brand CSS vars after a save, and to
 * suspend the org brand on the shell while a per-event theme owns the document.
 */
import { create } from 'zustand'

interface BrandStore {
  version: number
  /** Call after saving brand settings to trigger a re-apply in AppLayout */
  bump: () => void
  /**
   * True while useEventThemeOnDocument has an event theme applied to <html>.
   * AppLayout then clears the org-brand vars from the shell: the shell is a
   * DOM DESCENDANT of <html>, so its inline org values would otherwise mask
   * the event's primary/button/link tokens and `/event/:id` would render a
   * hybrid (event surfaces, org buttons) that `/event/public/:token` doesn't.
   */
  eventThemeActive: boolean
  setEventThemeActive: (active: boolean) => void
}

export const useBrandStore = create<BrandStore>((set) => ({
  version: 0,
  bump: () => set((s) => ({ version: s.version + 1 })),
  eventThemeActive: false,
  setEventThemeActive: (active) => set({ eventThemeActive: active }),
}))
